module.exports = __webpack_public_path__ + "img/pubgm.8b4132d.jpg";